export const SvgChevronLeft = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M11.75 15.5L4.25 8L11.75 0.5' stroke='var(--color-text)' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const SvgChevronRight = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M4.25 15.5L11.75 8L4.25 0.5' stroke='var(--color-text)' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const SvgChevronDown = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path d='M0.5 4.25L8 11.75L15.5 4.25' stroke='var(--color-text)' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const SvgClose = ({ color = '--color-text', ariaHidden = false }) => <svg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg' {...ariaHidden && { 'aria-hidden': true }}><path stroke={color} strokeLinecap='round' strokeLinejoin='round' d='m15.5.5-15 15m0-15 15 15' /></svg>